import { CircleAlert, CircleCheck } from "lucide-react";
import "./snackbar.css";
import { useEffect, useState } from "react";

export const Snackbar = ({ open, message, severity, onclose }) => {
  return (
    <div className={`snackbar ${severity} ${open ? "show" : ""}`}>
      <svg class="snackbar-icon" viewBox="0 0 24 24">
        {severity === "success" && <CircleCheck />}
        {severity === "error" && <CircleAlert />}
      </svg>
      <span>{message}</span>
      <button className="snackbar-close" onClick={onclose}>
        ×
      </button>
    </div>
  );
};

// import React from "react";
// import "./toaster.css";

// export const Snackbar = ({
//   open = false,
//   message = "",
//   severity = "info",
//   onClose,
//   className = "",
//   position = "bottom-center",
//   autoHideDuration = 5000,
// }) => {

//   React.useEffect(() => {
//     if (open && autoHideDuration) {
//       const timer = setTimeout(onClose, autoHideDuration);
//       return () => clearTimeout(timer);
//     }
//   }, [open, autoHideDuration, onClose]);

//   if (!open) return null;

//   const positionClasses = {
//     "top-center": "top-20 start-50",
//     "bottom-center": "bottom-20 start-50",
//     "top-right": "top-20 end-20",
//     "bottom-left": "bottom-20 start-20",
//   }[position];

//   return (
//     <div
//       className={`
//         d-flex position-fixed ${positionClasses} translate-middle-x
//         rounded text-white  bg-${severity} border-left-${severity}
//         slide-In min-w-300 max-w-95 z-index-1000 align-center
//         p-3 px-4 gap-3 ${className}
//       `}
//       role="alert"
//       aria-live="polite"
//     >
//       <div className="d-flex align-center  w-100 gap-10">
//         <SeverityIcon severity={severity} className="icon-sm" />
//         <p className="message mr-Auto">{message}</p>
//       </div>

//       <button
//         className="ml-auto bg-transparent border-0 text-white  cursor-pointer transition-all opacity-80 font-25"
//         onClick={onClose}
//         aria-label="Close"
//       >
//         &times;
//       </button>
//     </div>
//   );
// };

// const SeverityIcon = ({ severity, className }) => {
//   const iconClasses = `${className}`;

//   const icons = {
//     success: (
//       <svg
//         xmlns="http://www.w3.org/2000/svg"
//         width="40"
//         height="40"
//         viewBox="0 0 40 40"
//         fill="none"
//         className={iconClasses}
//       >
//         <path
//           d="M16.1834 18.8166C15.8695 18.5028 15.4439 18.3265 15 18.3265C14.5562 18.3265 14.1305 18.5028 13.8167 18.8166C13.5029 19.1305 13.3265 19.5561 13.3265 20C13.3265 20.4438 13.5029 20.8695 13.8167 21.1833L18.8167 26.1833C18.9724 26.3378 19.1571 26.46 19.3602 26.5429C19.5632 26.6259 19.7807 26.6679 20 26.6666C20.2282 26.6594 20.4524 26.6054 20.6589 26.5079C20.8653 26.4104 21.0495 26.2716 21.2 26.1L32.8667 12.7666C33.1361 12.4322 33.266 12.0067 33.2293 11.5788C33.1926 11.1509 32.9921 10.7537 32.6697 10.47C32.3473 10.1863 31.9279 10.038 31.4988 10.056C31.0697 10.074 30.6642 10.2569 30.3667 10.5666L20 22.5666L16.1834 18.8166Z"
//           fill="#fff"
//         />
//         <path
//           d="M35 18.3333C34.558 18.3333 34.1341 18.5089 33.8215 18.8215C33.5089 19.134 33.3333 19.558 33.3333 20C33.3333 23.5362 31.9286 26.9276 29.4281 29.4281C26.9276 31.9286 23.5362 33.3333 20 33.3333C17.3668 33.3321 14.793 32.5513 12.603 31.0892C10.4129 29.6272 8.70489 27.5494 7.69415 25.1179C6.68341 22.6865 6.41525 20.0101 6.9235 17.4265C7.43174 14.8428 8.69362 12.4675 10.55 10.6C11.7845 9.34895 13.2561 8.35672 14.8788 7.68134C16.5014 7.00595 18.2424 6.661 20 6.66665C21.0658 6.67332 22.1276 6.79627 23.1667 7.03331C23.3841 7.10057 23.613 7.12258 23.8393 7.09798C24.0656 7.07338 24.2844 7.00269 24.4823 6.89028C24.6803 6.77786 24.853 6.6261 24.99 6.44435C25.1271 6.2626 25.2254 6.05471 25.279 5.8335C25.3326 5.61229 25.3403 5.38245 25.3017 5.15815C25.263 4.93384 25.1788 4.71983 25.0543 4.5293C24.9298 4.33877 24.7676 4.17576 24.5777 4.05033C24.3877 3.9249 24.1741 3.8397 23.95 3.79998C22.6553 3.49538 21.3301 3.33883 20 3.33331C16.7072 3.35042 13.4933 4.34251 10.7638 6.1844C8.03436 8.02629 5.91163 10.6354 4.66355 13.6825C3.41546 16.7296 3.09794 20.0782 3.75107 23.3056C4.4042 26.533 5.9987 29.4946 8.33335 31.8166C11.4278 34.9125 15.6228 36.6564 20 36.6666C24.4203 36.6666 28.6595 34.9107 31.7851 31.7851C34.9107 28.6595 36.6667 24.4203 36.6667 20C36.6667 19.558 36.4911 19.134 36.1785 18.8215C35.866 18.5089 35.442 18.3333 35 18.3333Z"
//           fill="#fff"
//         />
//       </svg>
//     ),
//     error: (
//       <svg
//         xmlns="http://www.w3.org/2000/svg"
//         width="34"
//         height="33"
//         viewBox="0 0 34 33"
//         fill="none"
//         className={iconClasses}
//       >
//         <g clip-path="url(#clip0_1587_2903)">
//           <path
//             d="M17 0C7.61175 0 0 7.38787 0 16.5C0 25.6121 7.61175 33 17 33C26.3883 33 34 25.6121 34 16.5C34 7.38787 26.3883 0 17 0ZM17 30.9375C8.7975 30.9375 2.125 24.4612 2.125 16.5C2.125 8.53875 8.7975 2.0625 17 2.0625C25.2025 2.0625 31.875 8.53875 31.875 16.5C31.875 24.4612 25.2025 30.9375 17 30.9375ZM17 6.1875C16.4364 6.1875 15.8959 6.4048 15.4974 6.79159C15.0989 7.17839 14.875 7.70299 14.875 8.25V18.5625C14.875 19.1095 15.0989 19.6341 15.4974 20.0209C15.8959 20.4077 16.4364 20.625 17 20.625C17.5636 20.625 18.1041 20.4077 18.5026 20.0209C18.9011 19.6341 19.125 19.1095 19.125 18.5625V8.25C19.125 7.70299 18.9011 7.17839 18.5026 6.79159C18.1041 6.4048 17.5636 6.1875 17 6.1875ZM14.875 24.717C14.875 25.264 15.0989 25.7886 15.4974 26.1754C15.8959 26.5622 16.4364 26.7795 17 26.7795C17.5636 26.7795 18.1041 26.5622 18.5026 26.1754C18.9011 25.7886 19.125 25.264 19.125 24.717C19.125 24.4461 19.07 24.1779 18.9632 23.9277C18.8565 23.6775 18.6999 23.4501 18.5026 23.2586C18.3053 23.0671 18.071 22.9151 17.8132 22.8115C17.5554 22.7078 17.2791 22.6545 17 22.6545C16.7209 22.6545 16.4446 22.7078 16.1868 22.8115C15.929 22.9151 15.6947 23.0671 15.4974 23.2586C15.3001 23.4501 15.1435 23.6775 15.0368 23.9277C14.93 24.1779 14.875 24.4461 14.875 24.717Z"
//             fill="#fff"
//           />
//         </g>
//         <defs>
//           <clipPath id="clip0_1587_2903">
//             <rect width="34" height="33" fill="white" />
//           </clipPath>
//         </defs>
//       </svg>
//     ),
//     warning: (
//       <svg
//         xmlns="http://www.w3.org/2000/svg"
//         width="40"
//         height="40"
//         viewBox="0 0 40 40"
//         fill="none"
//         className={iconClasses}
//       >
//         <path
//           d="M20 9.18502C20.935 9.18502 21.865 9.77502 22.5733 10.955L32.4267 27.3784C33.845 29.7367 32.75 31.6667 30 31.6667H9.99999C7.24999 31.6667 6.15499 29.735 7.57332 27.3784L17.4267 10.955C18.135 9.77502 19.065 9.18502 20 9.18502ZM20 5.85168C17.84 5.85168 15.8633 7.08502 14.5683 9.23668L4.71498 25.6634C3.40498 27.845 3.26165 30.1717 4.32332 32.0467C5.38499 33.9217 7.45499 35 9.99999 35H30C32.545 35 34.6167 33.9234 35.6767 32.0484C36.7367 30.1734 36.595 27.8467 35.285 25.665L25.4317 9.24168C24.1367 7.08502 22.16 5.85168 20 5.85168Z"
//           fill="#fff"
//         />
//         <path
//           d="M20 28.8333C21.1966 28.8333 22.1666 27.8633 22.1666 26.6667C22.1666 25.4701 21.1966 24.5 20 24.5C18.8034 24.5 17.8333 25.4701 17.8333 26.6667C17.8333 27.8633 18.8034 28.8333 20 28.8333Z"
//           fill="#fff"
//         />
//         <path
//           d="M22.5 16.6667C22.5 15.2834 21.3816 14.1667 20 14.1667C19.5908 14.1668 19.1879 14.2673 18.8266 14.4596C18.4654 14.6518 18.157 14.9299 17.9283 15.2692C17.6997 15.6086 17.558 15.999 17.5155 16.4059C17.4731 16.8129 17.5313 17.2241 17.685 17.6034C18.6083 19.8967 20 23.3334 20 23.3334L22.3183 17.6034C22.4316 17.315 22.5 16.9984 22.5 16.6667Z"
//           fill="#fff"
//         />
//       </svg>
//     ),
//     info: (
//       <svg
//         xmlns="http://www.w3.org/2000/svg"
//         width="32"
//         height="37"
//         viewBox="0 0 32 37"
//         fill="none"
//         className={iconClasses}
//       >
//         <path
//           fill-rule="evenodd"
//           clip-rule="evenodd"
//           d="M14.4 13.1581C14.1889 12.9474 14.0231 12.6949 13.913 12.4163C13.8028 12.1378 13.7508 11.8392 13.76 11.5394C13.76 10.8919 13.9657 10.3369 14.4 9.92061C14.8343 9.50436 15.36 9.27311 16 9.27311C16.64 9.27311 17.1886 9.48124 17.6 9.92061C18.0114 10.36 18.24 10.8919 18.24 11.5394C18.24 12.1869 18.0343 12.7419 17.6 13.1581C17.178 13.5938 16.6029 13.8432 16 13.8519C15.36 13.8519 14.8114 13.5975 14.4 13.1581ZM18.2857 18.4769C18.24 17.8987 18.0343 17.3669 17.5771 16.8812C17.12 16.4419 16.6171 16.1875 16 16.1644H13.7143C13.0971 16.2106 12.6171 16.465 12.1371 16.8812C11.68 17.3437 11.4514 17.8987 11.4286 18.4769H13.7143V25.4144C13.76 26.0387 13.9657 26.5706 14.4229 27.01C14.88 27.4725 15.3829 27.7269 16 27.7269H18.2857C18.9029 27.7269 19.3829 27.4725 19.8629 27.01C20.32 26.5706 20.5486 26.0387 20.5714 25.4144H18.2857V18.4537V18.4769ZM16 5.31874C8.82286 5.31874 2.97143 11.1925 2.97143 18.4537C2.97143 25.715 8.82286 31.635 16 31.635C23.1771 31.635 29.0286 25.7381 29.0286 18.4537C29.0286 11.1694 23.1771 5.29561 16 5.29561V5.31874ZM16 2.26624C24.8229 2.26624 32 9.52749 32 18.4537C32 27.38 24.8229 34.6412 16 34.6412C7.17714 34.6412 0 27.4262 0 18.4537C0 9.48124 7.17714 2.26624 16 2.26624Z"
//           fill="#fff"
//         />
//       </svg>
//     ),
//   };

//   return icons[severity] || icons.info;
// };
